// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2GcI2","title":"Header_title__3ClGQ","side":"Header_side__2OuCf"};